/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateIsrcResponseMatchesInner
 */
export interface ValidateIsrcResponseMatchesInner {
    /**
     * 
     * @type {string}
     * @memberof ValidateIsrcResponseMatchesInner
     */
    recordingId: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateIsrcResponseMatchesInner
     */
    recordingTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateIsrcResponseMatchesInner
     */
    artistName?: string;
    /**
     * OpenSearch document _id
     * @type {string}
     * @memberof ValidateIsrcResponseMatchesInner
     */
    documentId: string;
}

/**
 * Check if a given object implements the ValidateIsrcResponseMatchesInner interface.
 */
export function instanceOfValidateIsrcResponseMatchesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    isInstance = isInstance && "documentId" in value;

    return isInstance;
}

export function ValidateIsrcResponseMatchesInnerFromJSON(json: any): ValidateIsrcResponseMatchesInner {
    return ValidateIsrcResponseMatchesInnerFromJSONTyped(json, false);
}

export function ValidateIsrcResponseMatchesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateIsrcResponseMatchesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recordingId': json['recordingId'],
        'recordingTitle': !exists(json, 'recordingTitle') ? undefined : json['recordingTitle'],
        'artistName': !exists(json, 'artistName') ? undefined : json['artistName'],
        'documentId': json['documentId'],
    };
}

export function ValidateIsrcResponseMatchesInnerToJSON(value?: ValidateIsrcResponseMatchesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recordingId': value.recordingId,
        'recordingTitle': value.recordingTitle,
        'artistName': value.artistName,
        'documentId': value.documentId,
    };
}

